// @flow
export default (props) => {
	switch (props.decorator || props.is) {
		case 'EshopPhotogallery':
			return import('fg-frontend/components/EshopPhotogallery');
		case 'EshopModel3D':
			return import('fg-frontend/components/EshopModel3D');
		case 'EshopImageMagnify':
			return import('fg-frontend/components/EshopImageMagnify');
		case 'EshopGalleryPopup':
			return import('fg-frontend/components/EshopGalleryPopup');
		case 'EshopOrderForm':
			return import('fg-frontend/components/EshopOrderForm');
		case 'EshopFulltextAutocomplete':
			return import('fg-frontend/src/components/EshopFulltextAutocomplete');
		case 'ProductListSlider':
			return import('fg-frontend/components/ProductListSlider');
			// eshop - detail produktu - komponenta productDetailVariantForm - odkomentovat, pokud je na komponente nastaveno metadato <enableVariantStockHandler>true</enableVariantStockHandler>
		case 'EshopVariantStockHandler':
			return import('fg-frontend/src/components/EshopVariantStockHandler');
		case 'EshopUserToolsHandler':
			// ESHOP: Handler komponenta pro pridani/odebrani produktu z oblibenych/porovnavani (odeberte, pokud na projektu nepouzivate ani oblibene ani porovnavani)
			return import('./components/EshopUserToolsHandler');
		case 'EshopProductTile':
			// ESHOP: slouží pro pokročilé ovládání dlaždice produktu
			return import('./components/EshopProductTile');
    case 'GooglePayHandler':
      // ESHOP: Handler pro platbu GooglePay (odeberte, pokud neni v projektu CSOB Google Pay)
      return import('fg-frontend/src/components/GooglePayHandler');
    case 'ApplePayHandler':
      // ESHOP: Handler pro platbu ApplePay (odeberte, pokud neni v projektu CSOB Apple Pay)
      return import('fg-frontend/src/components/ApplePayHandler');
    case 'PaymentsFilter':
      // ESHOP: Vyfiltruje/schova nepouzitelne platby zavisle na browseru (ApplePay) (odeberte, pokud neni v projektu CSOB Apple Pay)
      return import('fg-frontend/src/components/PaymentsFilter');
  }
};



// WEBPACK FOOTER //
// ./fe/web-kanken/src/js/configureEshopComponents.js